import risk1 from "assets/images/risk1.svg"
import risk2 from "assets/images/risk2.svg"
import risk3 from "assets/images/risk3.svg"
import risk4 from "assets/images/risk4.svg"
import risk5 from "assets/images/risk5.svg"

const RiskScale = ({ risk }) => {
  let svg;
  switch (risk) {
    case 1:
      svg = risk1;
      break;
    case 2:
      svg = risk2;
      break;
    case 3:
      svg = risk3;
      break;
    case 4:
      svg = risk4;
      break;
    default:
      svg = risk5;
      break;
  }

  return (
    risk ? (
      <img
        style={{ display: 'flex', width: '28px', height: '4px'}}
        src={svg}
        alt="risk"
      />
    ) : null
  )
}

export default RiskScale;